import { Toast } from 'primereact/toast';
import React, { useEffect, useRef } from 'react'
import Player from '@vimeo/player';

const VideoPlayer = ({ url, getDuration }) => {
    const iframeRef = useRef(null);
    const toast = useRef(null);

    useEffect(() => {
        if (!iframeRef.current || !url) return;

        const player = new Player(iframeRef.current);

        player.ready()
            .then(() => player.getDuration())
            .then((duration) => {
                getDuration(duration);
            })
            .catch((err) => {
                console.log('Error:', err);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Could not fetch video duration',
                });
            });

        return () => player.destroy();
    }, [url]);

    return (
        <>
            <Toast ref={toast} />
            {/* Hidden iframe just to get duration */}
            <iframe
                ref={iframeRef}
                src={url}
                style={{ display: 'none' }}
                allow="autoplay"
            />
        </>
    );
};

export default VideoPlayer;